import { render } from "./SecurityControl.vue?vue&type=template&id=7a2e7581"
import script from "./SecurityControl.vue?vue&type=script&lang=js"
export * from "./SecurityControl.vue?vue&type=script&lang=js"

import "./SecurityControl.vue?vue&type=style&index=0&id=7a2e7581&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__